// src/services/bi/charts/TopProspectsEvolutionChart.jsx
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Dot } from 'recharts';

const TopProspectsEvolutionChart = ({ data }) => {
  if (!data || data.length === 0) {
    return <div className="chart-empty">Aucune donnée disponible</div>;
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const value = payload[0].value;
      const count = payload[0].payload.prospects_count;
      return (
        <div className="evolution-tooltip">
          <p className="evolution-tooltip__day">{label}</p>
          <p className="evolution-tooltip__score">Score moyen : {value}%</p>
          {count > 0 && (
            <p className="evolution-tooltip__count">{count} prospect{count > 1 ? 's' : ''} qualifié(s)</p>
          )}
        </div>
      );
    }
    return null;
  };

  const CustomDot = (props) => {
    const { cx, cy, value } = props;
    if (value > 0) {
      return <Dot cx={cx} cy={cy} r={6} fill="#f97316" stroke="#fff" strokeWidth={2} />;
    }
    return <Dot cx={cx} cy={cy} r={4} fill="#cbd5e1" stroke="#fff" strokeWidth={1} />;
  };

  // Calcul de la tendance sur les scores moyens (pas sur le nombre)
  const trend = () => {
    if (data.length < 2) return '➡️ Stable';
    const first = data[0].average_score;
    const last = data[data.length - 1].average_score;
    if (last > first) return '📈 En hausse';
    if (last < first) return '📉 En baisse';
    return '➡️ Stable';
  };

  // Variation en pourcentage
  const variation = () => {
    if (data.length < 2) return null;
    const first = data[0].average_score;
    const last = data[data.length - 1].average_score;
    if (first === 0) return null;
    const delta = last - first;
    return `${delta > 0 ? '+' : ''}${delta} points`;
  };

  return (
    <div className="top-prospects-evolution">
      <ResponsiveContainer width="100%" height={260}>
        <LineChart data={data} margin={{ top: 20, right: 30, left: 10, bottom: 10 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" vertical={false} />
          <XAxis dataKey="day" tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={false} tickLine={false} />
          <YAxis 
            tick={{ fontSize: 12, fill: '#6b7280' }} 
            axisLine={false} 
            tickLine={false} 
            domain={[0, 100]} 
            tickFormatter={(tick) => `${tick}%`}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="average_score"
            stroke="#f97316"
            strokeWidth={3}
            dot={<CustomDot />}
            activeDot={{ r: 8, fill: '#f97316', stroke: '#fff', strokeWidth: 2 }}
            connectNulls={false}
          />
        </LineChart>
      </ResponsiveContainer>
      <div className="evolution-info">
        <span className="evolution-info__label">Tendance :</span>
        <span className="evolution-info__value">{trend()}</span>
        {variation() && (
          <span className="evolution-info__variation">({variation()})</span>
        )}
      </div>
    </div>
  );
};

export default TopProspectsEvolutionChart;